import { DATE_FORMAT_V2_FULL } from "@/utils";
import moment from "moment";
import { mapState } from "vuex";
import { Role } from "../../components/commons/commonConstant";
import {
  convertObjectToParams,
  formatDate,
  getContractType,
  getMessages,
  scaleScreen,
} from "../../components/commons/commons";
import FilterLayout from "../../components/layouts/FilterLayout";
const columns = [
  {
    title: "SF4C ID",
    dataIndex: "sf4c_id",
    key: "sf4c_id",
    scopedSlots: { customRender: "sf4c_id" },
  },
  {
    title: "Username",
    dataIndex: "user_name",
    key: "user_name",
    scopedSlots: { customRender: "user_name" },
  },
  {
    title: "Full Name",
    dataIndex: "full_name",
    key: "full_name",
    scopedSlots: { customRender: "full_name" },
  },
  {
    title: "Birthday",
    dataIndex: "date_of_birth",
    key: "date_of_birth",
    scopedSlots: { customRender: "date_of_birth" },
  },
  {
    title: "Department",
    dataIndex: "department",
    key: "department",
    scopedSlots: { customRender: "department" },
  },
  {
    title: "Job Level",
    dataIndex: "jobLevel",
    key: "jobLevel",
    scopedSlots: { customRender: "jobLevel" },
  },
  {
    title: "Contract Type",
    dataIndex: "contract_type",
    key: "contract_type",
    align: "center",
    scopedSlots: { customRender: "contract_type" },
  },
  {
    title: "Remain Annual Leave",
    dataIndex: "remain_annual",
    key: "remain_annual",
    align: "center",
    scopedSlots: { customRender: "remain_annual" },
  },
  {
    title: "",
    dataIndex: "edit",
    key: "edit",
    width: "10px",
    scopedSlots: { customRender: "edit" },
  },
];
const sodaColumns = [
  {
    title: "Attendance Check ID",
    dataIndex: "sdsv_id",
    key: "sdsv_id",
    scopedSlots: { customRender: "sdsv_id" },
  },
  {
    title: "HRMS ID",
    dataIndex: "username",
    key: "username",
    scopedSlots: { customRender: "username" },
  },
  {
    title: "Start Date",
    dataIndex: "start_date",
    key: "start_date",
    scopedSlots: { customRender: "start_date" },
  },
  {
    title: "End Date",
    dataIndex: "end_date",
    key: "end_date",
    scopedSlots: { customRender: "end_date" },
  },
  {
    title: "Attendance Check System",
    dataIndex: "attendance_check_system",
    key: "attendance_check_system",
  },
  {
    title: "",
    dataIndex: "edit",
    key: "edit",
    width: "10px",
    align: "center",
    scopedSlots: { customRender: "edit" },
  },
  {
    title: "",
    dataIndex: "delete",
    key: "delete",
    width: "10px",
    align: "center",
    scopedSlots: { customRender: "delete" },
  },
];
const locations = [
  { id: 1, value: "" },
  { id: 2, value: "CGLOBALDN" },
  { id: 3, value: "CGLOBALHCM" },
  { id: 4, value: "CGLOBALHN" },
  { id: 5, value: "JPN.KAN" },
];
const roleJob = [
  { id: 1, value: "" },
  { id: 2, value: "Executive" },
  { id: 3, value: "Management" },
  { id: 4, value: "Para-Pro" },
  { id: 5, value: "Professional" },
];
const contractTypes = [
  { id: 1, value: "" },
  { id: 2, value: "1236" },
  { id: 3, value: "ANNEX" },
  { id: 4, value: "C" },
  { id: 5, value: "COLLA" },
  { id: 6, value: "P" },
  { id: 7, value: "SEA" },
  { id: 8, value: "SEV" },
  { id: 9, value: "T" },
  { id: 10, value: "UNLIMTED" },
];
const nationalities = [
  { id: 1, value: "" },
  { id: 2, value: "IND" },
  { id: 3, value: "JPN" },
  { id: 4, value: "VNM" },
];
const statusEmployee = [
  { id: 1, value: "Active" },
  { id: 2, value: "Terminated" },
];
const holidayCalendars = [
  { id: 1, value: "CMC JAPAN" },
  { id: 2, value: "CMC_GLOBAL_HOLIDAY" },
  { id: 3, value: "VNM_NPH" },
];
const attendanceCheckSystem = [
  { id: 1, value: "SPEEDGATE" },
  { id: 2, value: "CMCGLOBAL" },
];
export default {
  name: "Employee",
  components: {
    FilterLayout,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      roles: (state) => (state.user.userInfo.roles ? state.user.userInfo.roles : ""),
      timesheetUser: (state) => (state.timesheet.timesheetUser ? state.timesheet.timesheetUser : {}),
      departmentList: (state) => state.application.departmentList,
      loading: (state) => state.user.loading,
    }),
  },
  data() {
    return {
      page: "Employee List",
      columns,
      sodaColumns,
      locations,
      roleJob,
      contractTypes,
      nationalities,
      statusEmployee,
      holidayCalendars,
      attendanceCheckSystem,
      dataEmployee: [],
      dataSoda: [],
      dataFilters: {},
      dataFiltersSoda: {},
      role: Role,
      moment,
      currentPage: 1,
      pageSize: 10,
      total_items: 0,
      currentPageSoda: 1,
      pageSizeSoda: 10,
      total_itemsSoda: 0,
      form: this.$form.createForm(this, { name: "Employee" }),
      formSD: this.$form.createForm(this, { name: "Employee Soda" }),
      visibleModal: false,
      isEdit: false,
      tabSelected: "",
      firstCall: true,
      sort: { direction: -1 },
      timeout: null,
      idSodaUpdate: null,
      formDataSoda: {
        id: null,
        account_number: null,
        sdsv_id: "",
        ldap_id: "",
        start_date: null,
        end_date: null,
        sdsv_name: "",
        cmc_name: "",
        project: "",
        position: "",
        attendance_check_system: "",
      },
      formData: {
        id: null,
        full_name: "",
        gender: null,
        birthday_date: "",
        email: "",
        personal_email: "",
        username: "",
        company: "",
        location: "",
        department: "",
        sub_department1: "",
        sub_department2: "",
        division: "",
        employee_status: "",
        job_level: "",
        work_schedule_type: "",
        sf4c_id: "",
        contract_type_name: "",
        number_of_year: "",
        contract_start_date: null,
        contract_end_date: null,
        start_working_day: null,
        last_working_day: null,
        seniority_date: null,
        holiday_calendar_code: "",
        total_annual_leave: "",
        remain_annual_leave: "",
        remain_birthday_leave: "",
        remain_maternity_leave: "",
        remain_offset_leave: "",
        remain_unpaid_leave: "",
        annual_leave_start_date: null,
        annual_leave_end_date: null,
      },
      recordDetail: {},
      contractTypeName: "",
      parentCode: "",
      totalAnnualLeave: null,
      arrayFieldValue: [],
      workScheduleType: [
        { id: 1, value: "" },
        { id: 2, value: "FLEXIBLE" },
        { id: 3, value: "HCM" },
      ],
    };
  },
  watch: {
    loading() {
      console.log("loading", this.loading);
    },
  },

  created() {
    this.scaleScreen();
    this.firstCall = true;
    this.dataFilters = { ...this.dataFilters, ...JSON.parse(sessionStorage.getItem("Employee List")) };
    this.dataFiltersSoda = { ...this.dataFiltersSoda, ...JSON.parse(sessionStorage.getItem("EmployeeSD")) };
    this.tabSelected = "employeeList";
    this.formData = {
      company: "CMCGLOBAL",
    };
    // this.getEmployeeList();
  },
  methods: {
    formatDate,
    scaleScreen,
    customRow(i) {
      return {
        on: {
          click: () => {
            this.recordDetail = i;
            this.formData = {
              id: i.id,
              full_name: i.name,
              gender: i.gender ? i.gender : null,
              birthday_date: i.date_of_birth
                ? moment(moment(i.date_of_birth, "DD/MM/YYYY").format("YYYY-MM-DD"))
                : null,
              email: i.email,
              personal_email: i.personalEmail,
              username: i.user_name,
              company: i.company,
              location: i.location,
              department: i.department_name ? i.department_name.nameEn : "",
              sub_department1: i.sub_department,
              sub_department2: i.sub_department_2,
              division: i.division,
              employee_status: i.employeeStatus,
              job_level: i.jobLevel ? i.jobLevel : "",
              work_schedule_type: i.work_schedule_type ? i.work_schedule_type : undefined,
              work_schedule_apply_date: i.work_schedule_apply_date
                ? moment(moment(i.work_schedule_apply_date).format("YYYY-MM-DD"))
                : null,
              job_classfication: i.jobClassification,
              sf4c_id: i.sf4c_id,
              contract_type_name: i.contractTypeName,
              number_of_year: i.numberOfYear,
              contract_start_date: i.contract_start_date ? moment(i.contract_start_date, DATE_FORMAT_V2_FULL) : null,
              contract_end_date: i.contract_end_date ? moment(i.contract_end_date, DATE_FORMAT_V2_FULL) : null,
              start_working_day: i.start_working_day ? moment(i.start_working_day, DATE_FORMAT_V2_FULL) : null,
              last_working_day: i.last_working_day ? moment(i.last_working_day, DATE_FORMAT_V2_FULL) : null,
              seniority_date: i.seniorityDate ? moment(i.seniorityDate, DATE_FORMAT_V2_FULL) : null,
              holiday_calendar_code: i.holidayCalendarCode,
              total_annual_leave: i.total_annual_leave,
              remain_annual_leave: i.remain_annual_leave ? i.remain_annual_leave : "0",
              remain_birthday_leave: i.remain_birthday_leave,
              remain_maternity_leave: i.remain_maternity_leave,
              remain_offset_leave: i.remainOffsetLeave,
              remain_unpaid_leave: i.remain_unpaid_leave,
              annual_leave_start_date: i.annualLeaveStartDate
                ? moment(i.annualLeaveStartDate, DATE_FORMAT_V2_FULL)
                : null,
              annual_leave_end_date: i.annualLeaveEndDate ? moment(i.annualLeaveEndDate, DATE_FORMAT_V2_FULL) : null,
            };
            this.isEdit = true;
            this.tabSelected = "employee";
          },
        },
      };
    },
    changeContext(value) {
      let findDepartment = this.departmentList.find((item) => item.department_code === value);
      if (findDepartment) {
        this.parentCode = findDepartment.parent_code;
        this.form.setFieldsValue({ division: findDepartment.parent_code });
      }
    },
    onChangeGender(value) {
      this.form.setFieldsValue({ gender: value });
    },
    onChangeLocation(value) {
      this.form.setFieldsValue({ location: value });
    },
    onChangeStatusEmployee(value) {
      this.form.setFieldsValue({ employee_status: value });
    },
    onChangeJobLevel(value) {
      this.form.setFieldsValue({ job_level: value });
    },
    onChangeContractType(value) {
      this.form.setFieldsValue({ contract_type_name: value });
      this.contractTypeName = getContractType(value).name;
    },
    onChangeHoliday(value) {
      this.form.setFieldsValue({ holiday_calendar_code: value });
    },
    onChangeRemainAnnualLeave(value) {
      const { recordDetail } = this;
      if (!this.isEdit) {
        this.form.setFieldsValue({ total_annual_leave: value.target.value });
      } else {
        let index = -1;
        for (let i = 0; i < this.arrayFieldValue.length; i++) {
          if (this.arrayFieldValue[i].field === value.target.name) {
            index = i;
            break;
          }
        }
        if (index > -1) {
          if (value.target.value === "" || value.target.value === null) {
            this.arrayFieldValue.splice(index, 1);
            this.form.setFieldsValue({ total_annual_leave: recordDetail.total_annual_leave });
            // this.form.setFieldsValue({remain_annual_leave: recordDetail.remain_annual_leave})
          } else {
            this.arrayFieldValue[index].value = parseInt(value.target.value);
          }
        } else {
          let objEdit = {
            field: value.target.name,
            value: parseInt(value.target.value),
          };
          this.arrayFieldValue.push(objEdit);
        }
        this.getTotalAnnualleave(recordDetail);
      }
    },
    getTotalAnnualleave(recordDetail) {
      if (this.arrayFieldValue[0]) {
        if (this.arrayFieldValue[0].value > 0) {
          this.form.setFieldsValue({ remain_annual_leave: recordDetail.remain_annual_leave });
          this.form.setFieldsValue({ total_annual_leave: recordDetail.total_annual_leave });
          let change = this.arrayFieldValue[0].value;
          let up = change - this.form.getFieldValue("remain_annual_leave");
          let newTotal = (this.form.getFieldValue("total_annual_leave") + up).toString();
          this.form.setFieldsValue({ total_annual_leave: newTotal });
        } else if (this.arrayFieldValue[0].value === 0) {
          this.form.setFieldsValue({ remain_annual_leave: recordDetail.remain_annual_leave });
          this.form.setFieldsValue({ total_annual_leave: recordDetail.total_annual_leave });
          let change = this.arrayFieldValue[0].value;
          let down = this.form.getFieldValue("remain_annual_leave") - change;
          let newTotal = (this.form.getFieldValue("total_annual_leave") - down).toString();
          this.form.setFieldsValue({ total_annual_leave: newTotal });
        } else if (Number.isNaN(this.arrayFieldValue[0].value)) {
          this.arrayFieldValue[0].value = 0;
          this.form.setFieldsValue({ remain_annual_leave: recordDetail.remain_annual_leave });
          this.form.setFieldsValue({ total_annual_leave: recordDetail.total_annual_leave });
          let change = this.arrayFieldValue[0].value;
          let down = this.form.getFieldValue("remain_annual_leave") - change;
          let newTotal = (this.form.getFieldValue("total_annual_leave") - down).toString();
          this.form.setFieldsValue({ total_annual_leave: newTotal });
        } else if (this.arrayFieldValue[0].value < 0) {
          this.$message.error("Remain Annual Leave must be positive number", 5);
        }
      }
    },
    onChangeAccountNumber(e) {
      if (isNaN(e.target.value)) {
        alert("Must input numbers!");
      }
    },
    onChangeAttemdance(value) {
      this.formSD.setFieldsValue({ attendance_check_system: value });
    },
    handleChangeTab(key) {
      this.tabSelected = key;
      this.isEdit = false;
      this.formData = {
        company: "CMCGLOBAL",
      };
      // this.form.resetFields()
    },
    showModalCreate() {
      this.visibleModal = true;
      this.isEdit = false;
      this.formDataSoda = {};
      this.formSD.resetFields();
    },
    showEmployeeEdit(i, key) {
      this.recordDetail = i;
      this.tabSelected = key;
      this.isEdit = true;
      this.form.resetFields();
      this.formData = {
        id: i.id,
        full_name: i.name,
        gender: i.gender ? i.gender : null,
        birthday_date: i.date_of_birth ? moment(moment(i.date_of_birth, "DD/MM/YYYY").format("YYYY-MM-DD")) : null,
        email: i.email,
        personal_email: i.personalEmail,
        username: i.user_name,
        company: i.company,
        location: i.location,
        department: i.department_name ? i.department_name.nameEn : "",
        sub_department1: i.sub_department,
        sub_department2: i.sub_department_2,
        division: i.division,
        employee_status: i.employeeStatus,
        job_level: i.jobLevel ? i.jobLevel : "",
        work_schedule_type: i.work_schedule_type ? i.work_schedule_type : undefined,
        work_schedule_apply_date: i.work_schedule_apply_date
          ? moment(moment(i.work_schedule_apply_date).format("YYYY-MM-DD"))
          : null,
        job_classfication: i.jobClassification,
        sf4c_id: i.sf4c_id,
        contract_type_name: i.contractTypeName,
        number_of_year: i.numberOfYear,
        contract_start_date: i.contract_start_date ? moment(i.contract_start_date, DATE_FORMAT_V2_FULL) : null,
        contract_end_date: i.contract_end_date ? moment(i.contract_end_date, DATE_FORMAT_V2_FULL) : null,
        start_working_day: i.start_working_day ? moment(i.start_working_day, DATE_FORMAT_V2_FULL) : null,
        last_working_day: i.last_working_day ? moment(i.last_working_day, DATE_FORMAT_V2_FULL) : null,
        seniority_date: i.seniorityDate ? moment(i.seniorityDate, DATE_FORMAT_V2_FULL) : null,
        holiday_calendar_code: i.holidayCalendarCode,
        total_annual_leave: i.total_annual_leave,
        remain_annual_leave: i.remain_annual_leave,
        remain_birthday_leave: i.remain_birthday_leave,
        remain_maternity_leave: i.remain_maternity_leave,
        remain_offset_leave: i.remainOffsetLeave,
        remain_unpaid_leave: i.remain_unpaid_leave,
        annual_leave_start_date: i.annualLeaveStartDate ? moment(i.annualLeaveStartDate, DATE_FORMAT_V2_FULL) : null,
        annual_leave_end_date: i.annualLeaveEndDate ? moment(i.annualLeaveEndDate, DATE_FORMAT_V2_FULL) : null,
      };
    },
    showModalEdit(i) {
      this.visibleModal = true;
      this.isEdit = true;
      this.formDataSoda = {
        id: i.id,
        account_number: i.account_number,
        sdsv_id: i.attendance_check_id,
        ldap_id: i.hrms_username,
        start_date: i.start_date ? moment(moment(i.start_date, "DD/MM/YYYY").format("YYYY-MM-DD")) : null,
        end_date: i.end_date ? moment(moment(i.end_date, "DD/MM/YYYY").format("YYYY-MM-DD")) : null,
        sdsv_name: i.attendance_check_name,
        cmc_name: i.hrms_name,
        project: i.project,
        position: i.position,
        attendance_check_system: i.attendance_check_system,
      };
    },
    handleSubmitEmployee(e) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        e.preventDefault();
        this.$emit("click");
        this.form.validateFields((error, values) => {
          if (!error) {
            let payload = {
              contractTypeName: this.contractTypeName,
              gender: values.gender ? values.gender : null,
              sf4c_id: values.sf4c_id ? values.sf4c_id : null,
              name: this.checkPayloadSubmit(values.full_name),
              email: this.checkPayloadSubmit(values.email),
              personalEmail: this.checkPayloadSubmit(values.personal_email),
              user_name: this.checkPayloadSubmit(values.username),
              company: this.checkPayloadSubmit(values.company),
              location: this.checkPayloadSubmit(values.location),
              department: this.checkPayloadSubmit(values.department),
              sub_department: this.checkPayloadSubmit(values.sub_department1),
              sub_department_2: this.checkPayloadSubmit(values.sub_department2),
              division: this.checkPayloadSubmit(values.division),
              employeeStatus: this.checkPayloadSubmit(values.employee_status),
              jobLevel: this.checkPayloadSubmit(values.job_level),
              work_schedule_type: this.checkPayloadSubmit(values.work_schedule_type),
              work_schedule_apply_date: values.work_schedule_apply_date
                ? moment(values.work_schedule_apply_date).format("YYYY-MM-DD HH:mm:ss")
                : "",
              contract_type: this.checkPayloadSubmit(values.contract_type_name),
              numberOfYear: this.checkPayloadSubmit(values.number_of_year),
              holidayCalendarCode: this.checkPayloadSubmit(values.holiday_calendar_code),
              total_annual_leave: this.checkPayloadSubmit(values.total_annual_leave),
              remain_annual_leave: this.checkPayloadSubmit(values.remain_annual_leave),
              remain_unpaid_leave: this.checkPayloadSubmit(values.remain_unpaid_leave),
              remain_maternity_leave: this.checkPayloadSubmit(values.remain_maternity_leave),
              remain_birthday_leave: this.checkPayloadSubmit(values.remain_birthday_leave),
              remainOffsetLeave: this.checkPayloadSubmit(values.remain_offset_leave),
              date_of_birth: values.birthday_date ? values.birthday_date : null,
              contract_start_date: this.checkPayloadSubmitMoment(values.contract_start_date),
              contract_end_date: this.checkPayloadSubmitMoment(values.contract_end_date),
              start_working_day: this.checkPayloadSubmitMoment(values.start_working_day),
              last_working_day: this.checkPayloadSubmitMoment(values.last_working_day),
              seniorityDate: this.checkPayloadSubmitMoment(values.seniority_date),
              annualLeaveStartDate: this.checkPayloadSubmitMoment(values.annual_leave_start_date),
              annualLeaveEndDate: this.checkPayloadSubmitMoment(values.annual_leave_end_date),
            };
            if (!this.isEdit) {
              this.checkCreate(payload);
            } else {
              this.checkUpdate(payload);
            }
          } else {
            this.$message.error(error, 5);
          }
        });
      }, 300);
    },
    checkCreate(payload) {
      this.$store
        .dispatch("employee/createEmployeeListRequest", payload)
        .then((res) => {
          if (parseInt(res.code) === 489) {
            getMessages(res.messages).forEach((msg) => {
              this.$message.success(msg, 5);
            });
            this.getEmployeeList();
            this.visibleModal = false;
            this.form.resetFields();
          } else {
            getMessages(res.messages).forEach((msg) => {
              this.$message.error(msg, 5);
            });
          }
        })
        .catch((err) => {
          getMessages(err.response.data.messages).forEach((msg) => {
            this.$message.error(msg, 5);
          });
        });
    },
    checkUpdate(payload) {
      payload.id = this.formData.id;
      this.$store
        .dispatch("employee/updateEmployeeList", payload)
        .then((res) => {
          if (parseInt(res.code) === 200) {
            getMessages(res.messages).forEach((msg) => {
              this.$message.success(msg, 5);
            });
            this.getEmployeeList();
            this.isEdit = false;
            this.formData = {};
            this.form.resetFields();
          } else {
            getMessages(res.messages).forEach((msg) => {
              this.$message.error(msg, 5);
            });
          }
        })
        .catch((err) => {
          getMessages(err.response.data.messages).forEach((msg) => {
            this.$message.error(msg, 5);
          });
        });
    },
    checkPayloadSubmit(data) {
      return data ? data : "";
    },
    checkPayloadSubmitMoment(data) {
      return data ? moment(data).format(DATE_FORMAT_V2_FULL) : "";
    },
    handleSubmit(e) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        e.preventDefault();
        this.$emit("click");
        this.formSD.validateFields((error, values) => {
          if (!error) {
            let payload = {
              account_number: parseInt(values.account_number),
              attendance_check_id: values.sdsv_id,
              hrms_name: values.cmc_name,
              attendance_check_name: values.sdsv_name,
              project: values.project,
              hrms_username: values.ldap_id,
              position: values.position,
              attendance_check_system: values.attendance_check_system,
              start_date: moment(values.start_date).format("YYYY-MM-DD"),
              end_date: moment(values.end_date).format("YYYY-MM-DD"),
            };
            if (!this.isEdit && payload.end_date >= payload.start_date) {
              this.isCheckAddNew(payload);
            } else if (this.isEdit && payload.end_date >= payload.start_date) {
              this.isCheckEdit(payload);
            } else {
              this.$message.error("End date must higher than start date", 5);
            }
          } else {
            this.$message.error(error, 5);
          }
        });
      }, 300);
    },
    isCheckAddNew(payload) {
      this.$store
        .dispatch("employee/createRequest", payload)
        .then((res) => {
          if (parseInt(res.code) === 441) {
            this.$message.success(res.message, 5);
            this.getEmployeeSodaList();
            this.visibleModal = false;
            this.formSD.resetFields();
          } else {
            this.$message.error(res.message, 5);
          }
        })
        .catch((err) => {
          this.$message.error(err.message, 5);
        });
    },
    isCheckEdit(payload) {
      payload.id = this.formDataSoda.id;
      this.$store
        .dispatch("employee/updateEmployeeSoda", payload)
        .then((res) => {
          if (parseInt(res.code) === 443) {
            this.$message.success(res.message, 5);
            this.getEmployeeSodaList();
            this.visibleModal = false;
            this.formSD.resetFields();
          } else {
            this.$message.error(res.message, 5);
          }
        })
        .catch((err) => {
          this.$message.error(err.message, 5);
        });
    },
    deleteEmployeeSoda(i) {
      clearTimeout(this.timeout);
      this.$store
        .dispatch("employee/deleteEmployeeSoda", i.id)
        .then(() => {
          this.$message.success("Delete Attendance Check System successfully !!");
          this.getEmployeeSodaList();
        })
        .catch((err) => {
          this.$message.error(err.message, 5);
        });
    },

    ShowDeleteEmployeeSoda(i) {
      this.$confirm({
        title: "Confirm",
        content: "Do you want to delete this Attendance Check System?",
        okText: "Yes",
        onOk: () => {
          this.deleteEmployeeSoda(i);
        },
        cancelText: "No",
      });
    },
    handleCancel() {
      this.visibleModal = false;
      this.formDataSoda = {};
      this.formSD.resetFields();
    },
    handleCancelEmployee() {
      this.form.resetFields();
      this.formData = {
        company: "CMCGLOBAL",
      };
      this.isEdit = false;
    },
    getEmployeeSodaList() {
      this.$store.dispatch("user/loadingRequest");
      const { currentPageSoda, pageSizeSoda, sort, dataFiltersSoda } = this;
      let param = {};
      if (this.firstCall) {
        param = { ...dataFiltersSoda, ...sort };
        this.currentPageSoda = dataFiltersSoda.page ? dataFiltersSoda.page : 1;
        this.pageSizeSoda = dataFiltersSoda.size ? dataFiltersSoda.size : 10;
      } else {
        param = { ...dataFiltersSoda, ...sort, page: currentPageSoda, size: pageSizeSoda };
      }
      const url = convertObjectToParams(param);
      this.$store
        .dispatch("employee/getEmployeeSodaData", url)
        .then((res) => {
          let data = [];
          if (res.data) {
            data = res.data.map((element, key) => {
              element.key = key;
              element.sdsv_id = element.attendance_check_id;
              element.username = element.hrms_username;
              element.start_date = formatDate(element.start_date);
              element.end_date = formatDate(element.end_date);
              element.attendance_check_system = element.attendance_check_system ? element.attendance_check_system : "";
              return element;
            });
            this.total_itemsSoda = res.page.total_element;
            this.dataSoda = data;
            this.firstCall = false;
          }
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
      sessionStorage.setItem("EmployeeSD", JSON.stringify(param));
    },
    getEmployeeList() {
      this.$store.dispatch("user/loadingRequest");
      const { currentPage, pageSize, sort, dataFilters } = this;
      let param = {};
      if (this.firstCall) {
        param = { ...dataFilters, ...sort };
        this.currentPage = dataFilters.page ? dataFilters.page : 1;
        this.pageSize = dataFilters.size ? dataFilters.size : 10;
      } else {
        param = { ...dataFilters, ...sort, page: currentPage, size: pageSize };
      }
      const url = convertObjectToParams(param);
      this.$store
        .dispatch("employee/getEmployeeList", url)
        .then((res) => {
          let data = [];
          if (res.data) {
            data = this.getData(res);
            this.total_items = res.page.total_element;
            this.dataEmployee = data;
            this.firstCall = false;
          }
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
      sessionStorage.setItem("Employee List", JSON.stringify(param));
    },
    getData(res) {
      let data = [];
      data = res.data.map((element, key) => {
        element.key = key;
        element.full_name = element.name;
        element.date_of_birth = formatDate(element.date_of_birth);
        element.jobLevel = element.jobLevel ? element.jobLevel : "";
        element.contract_type = element.contract_type ? element.contract_type : "";
        element.remain_annual = element.remain_annual_leave ? element.remain_annual_leave : "0";
        element.department = element.department_name ? element.department_name.nameEn : "";
        return element;
      });
      return data;
    },
    onSetDataFilters(filters) {
      this.dataFilters = filters;
    },
    onSetDataFiltersSoda(filters) {
      this.dataFiltersSoda = filters;
    },
    onApplyFilters(filters) {
      this.dataFilters = filters;
      this.currentPage = 1;
      this.getEmployeeList();
    },
    onApplyFiltersSoda(filters) {
      this.dataFiltersSoda = filters;
      this.currentPageSoda = 1;
      this.getEmployeeSodaList();
    },
    onChangePage(page, size) {
      this.currentPage = page;
      this.pageSize = size;
      this.getEmployeeList();
    },
    onShowSizeChange(page, size) {
      this.currentPage = page;
      this.pageSizeSoda = size;
      this.getEmployeeList();
    },
    onChangePageSoda(page, size) {
      this.currentPageSoda = page;
      this.pageSizeSoda = size;
      this.getEmployeeSodaList();
    },
    onShowSizeChangeSoda(page, size) {
      this.currentPageSoda = page;
      this.pageSizeSoda = size;
      this.getEmployeeSodaList();
    },
  },
  destroyed() {
    this.$store.commit("user/RESET_LOADING");
  },
};
